import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { PetsService } from '../_services';


@Component({
  selector: 'app-extend-reminder',
  templateUrl: './extend-reminder.component.html',
  styleUrls: ['./extend-reminder.component.scss']
})
export class ExtendReminderComponent implements OnInit {
  errorContent: string;
  successContent: string;
  foundexpiredContent: string;
  missingexpiredContent: string;


  constructor(
    private activatedRoute: ActivatedRoute,
    private spinnerService: NgxSpinnerService,
    private petService: PetsService) { }

  ngOnInit(): void {
    let encryptedPetId = this.activatedRoute.snapshot.params['id'];
    if (encryptedPetId && encryptedPetId != undefined && encryptedPetId != '') {
      let lostfoundId = atob(encryptedPetId);
      this.extendReminder(parseInt(lostfoundId));
    }
  }

  extendReminder(lostfoundId: any) {
    this.spinnerService.show();
    this.petService.updatePetReminderDetail(lostfoundId).subscribe((res: any) => {
      this.spinnerService.hide();
      if (res.errorCode == 0) {
        this.successContent = 'PUBLICATION_REMINDER_SUCCESS';
      }
      if (res.errorCode == 1) {
        this.errorContent = 'PUBLICATION_ALREADY_EXTENDED';
      }
      if (res.errorCode == 2) {
        if (res.ExtraDetails == "1") {
          this.missingexpiredContent = 'PUBLICATION_MISSINGLINK_EXPIRED';
        }
        if (res.ExtraDetails == "2") {
          this.foundexpiredContent = 'PUBLICATION_FOUNDLINK_EXPIRED';
        }
      }
    });
  }
}
